
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const UserIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9.004" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.002 16.002a2.107 2.107 0 0 0-.529-.77v0a2.109 2.109 0 0 0-1.434-.564H9.962c-.532 0-1.045.202-1.435.564v0c-.231.215-.412.477-.529.77"/><circle cx="12" cy="10.249" r="2.251" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/></svg>
  </SvgIcon>
);
